import { CardStyle } from './Card.style';
import { CardProps } from './types';

const Card = ({
  children,
  onClick,
  bg = 'neutral.0',
  shadow = false,
  ...props
}: CardProps): JSX.Element => {
  return (
    <CardStyle tabIndex={0} bg={bg} onClick={onClick} shadow={shadow} {...props}>
      {children}
    </CardStyle>
  );
};
export { Card };
